<template>
    <div
        :style="componentStyles"
        class="o-guide-sidebar"
    >
        <OItemDetailsCompact
            :view="view"
            :item-id="itemId"
        />
        <OPathSteps
            :view="view"
            :item-id="itemId"
        />
        <OGuideQrCode
            :view="view"
            :item-id="itemId"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import OPathSteps from '../../organisms/o-path-steps';
import OGuideQrCode from '../../organisms/o-guide-qr-code';
import OItemDetailsCompact from '../../organisms/o-item-details-compact';
import {EVENTS} from "@/utils/constants/bus-events-constants";

export default {
    name: "OGuideSidebar",
    components: {
        OPathSteps,
        OGuideQrCode,
        OItemDetailsCompact
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    mounted() {
        this.closeModals();
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        itemId() {
            return Number(this.$route.params.itemId);
        },
        componentStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OGuideSidebar.styles`) || null;
        },
    },
    methods: {
        closeModals() {
            this.$bus.$emit(EVENTS.MODALS.OFF_MODAL, false);
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
